<template>
    <div>
        <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="18">
                <el-button :loading="exporting" icon="el-icon-download" @click="download">{{$t('common.export')}}</el-button>
            </el-col>
            <el-col :span="6">
                <el-input v-model="filter.part" :placeholder="$t('common.part')"></el-input>
            </el-col>
        </el-row>

        <el-table size="mini" :data="parts" v-loading="loading" class="tablewithshading">
            <el-table-column prop="partNo" :label="$t('common.number')" width="100"></el-table-column>
            <el-table-column prop="name" :label="$t('common.description')"></el-table-column>
            <el-table-column :label="$t('common.listPrice')" width="100">
                <template slot-scope="scope">
                    {{scope.row.price | money}}
                </template>
            </el-table-column>
            <el-table-column :label="$t('common.extendedPrice')" width="120">
                <template slot-scope="scope">
                    {{scope.row.extendedPrice | money}}
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pager" v-if="total !== 0" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="15" layout="total, prev, pager, next" :total="total">
        </el-pagination>
    </div>
</template>

<script>
import api from "../api";

export default {
  name: "price-list-report",
  data() {
    return {
      loading: false,
      parts: [],
      filter: {
        part: undefined,
        serviceCompany: window.currentCompany.id
      },
      currentPage: 1,
      total: 0,
      exporting: false
    };
  },
  created() {
    this.loadParts();
  },
  watch: {
    filter: {
      deep: true,
      handler: function(val) {
        this.currentPage = 1;
        this.loadParts();
      }
    }
  },
  methods: {
    loadParts() {
      this.loading = true;
      api.getParts(this.currentPage, this.filter).then(response => {
        this.loading = false;
        this.parts = response.data.items;
        this.total = response.data.total;
      });
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadParts();
    },
    download() {
      this.exporting = true;
      api
        .downloadPriceList(this.filter)
        .then(() => {
          this.exporting = false;
        })
        .catch(() => {
          this.exporting = false;
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// ClientApp/app/reports/components/PriceList.vue